import React, { useEffect, useCallback, useState, useRef } from "react";
import { Colors, Constants, Fonts, Images } from "../../../config";
import { StyleSheet, View, TouchableOpacity, Text } from "react-native-web";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import { getClass } from "../../../helpers/formatHelpers";

const FilterView = (props) => {
  const { t } = useTranslation();
  const { isMobileVersion, isChartsMode } = props;
  return (
    <View style={styles.container}>
      {!isChartsMode && (
        <TouchableOpacity
          style={styles.item}
          activeOpacity={1}
          onPress={() =>
            // props.dataCategory === Constants.categoryType.CATEGORY_ARTIST
            //   ? null
            //   :
            props.onPressLocation()
          }>
          <Image
            width={16}
            height={16}
            // style={
            //   props.dataCategory === Constants.categoryType.CATEGORY_ARTIST
            //     ? { opacity: 0.7 }
            //     : {}
            // }
            src={Images.iconLocationPin}
            alt="icon location"
          />
          <Text
            style={[
              [
                styles.label,
                isMobileVersion
                  ? {
                      fontSize: 12,
                      lineHeight: 18,
                    }
                  : {},
              ],
              // props.dataCategory === Constants.categoryType.CATEGORY_ARTIST
              //   ? { opacity: 0.7 }
              //   : {},
            ]}>
            {t("key_location")}
          </Text>
        </TouchableOpacity>
      )}
      <TouchableOpacity
        style={styles.item}
        activeOpacity={1}
        onPress={props.onPressFilter}>
        <Image
          width={16}
          height={16}
          src={Images.iconFilterColored}
          alt="icon filter"
        />
        <Text
          style={[
            styles.label,
            isMobileVersion
              ? {
                  fontSize: 12,
                  lineHeight: 18,
                }
              : {},
          ]}>
          {t("key_filter")}
        </Text>
        {props.isFiltered && <TouchableOpacity style={styles.dot} />}
      </TouchableOpacity>
      {!isChartsMode && (
        <TouchableOpacity
          style={[styles.item, { borderRightWidth: 0 }]}
          activeOpacity={1}
          onPress={props.onPressSort}>
          <Image
            width={16}
            height={16}
            src={Images.iconSortColored}
            alt="icon sort"
          />
          <Text
            style={[
              styles.label,
              isMobileVersion
                ? {
                    fontSize: 12,
                    lineHeight: 18,
                  }
                : {},
            ]}>
            {t("key_sort")}
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderTopWidth: 1,
    borderTopColor: getClass("bg-black2"),
    borderBottomWidth: 1,
    borderBottomColor: getClass("bg-black2"),
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  item: {
    borderRightWidth: 1,
    borderRightColor: getClass("bg-black2"),
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 10,
  },
  icon: {
    width: 12,
    height: 12,
  },
  label: {
    color: getClass("text-black3"),
    fontSize: 14,
    lineHeight: 18,
    marginLeft: 6,
    fontFamily: Fonts.primaryMedium,
  },
  dot: {
    backgroundColor: getClass("text-white"),
    borderRadius: 100,
    width: 4,
    height: 4,
    marginLeft: 6,
  },
});

export default FilterView;
